
import type { OptionTranslationsByLanguage } from "@/services/option-translation-service";

export type OptionData = {
  id: number;
  type_id: number;
  type_name?: string;
  type_code?: string;
  type_category?: string;
  type_identifier?: string;
  option_type_identifier?: string;
  long_name?: string;
  translations_by_language?: OptionTranslationsByLanguage | null;
  collection_id: number;
  building_id: string;
  unit_type_id: string;
  language: string;
  name: string;
  description: string;
  price: number;
  price_per_unit_of: string;
  price_per_interval_of: string;
  permission: string;
  vat_percentage: number;
  is_cleaning_supply?: boolean;
};

export default class Option {
  public id: number;
  public typeId: number;
  public typeName: string;
  public typeCode: string;
  public typeCategory: string;
  public longName: string;
  public translationsByLanguage: OptionTranslationsByLanguage | null;
  public collectionId: number;
  public buildingId: string;
  public unitTypeId: string;
  public language: string;
  public name: string;
  public description: string;
  public price: number;
  public pricePerUnitOf: string;
  public pricePerIntervalOf: string;
  public permission: string;
  public vatPercentage: number;
  public isCleaningSupply?: boolean;

  constructor(data: OptionData) {
    this.id = data.id as number;
    this.typeId = data.type_id as number;
    this.typeName = data.type_name ?? "";
    this.typeCode = data.type_code ?? data.type_identifier ?? data.option_type_identifier ?? "";
    this.typeCategory = data.type_category ?? "";
    this.longName = data.long_name ?? "";
    this.translationsByLanguage = data.translations_by_language ?? null;
    this.collectionId = data.collection_id as number;
    this.buildingId = data.building_id as string;
    this.unitTypeId = data.unit_type_id as string;
    this.language = data.language as string;
    this.name = data.name as string;
    this.description = data.description as string;
    this.price = data.price as number;
    this.pricePerUnitOf = data.price_per_unit_of as string;
    this.pricePerIntervalOf = data.price_per_interval_of as string;
    this.permission = data.permission as string;
    this.vatPercentage = data.vat_percentage as number;
    this.isCleaningSupply = data.is_cleaning_supply;
  }

  toDTO(): OptionData {
    return {
      id: this.id,
      type_id: this.typeId,
      type_name: this.typeName,
      type_code: this.typeCode,
      type_category: this.typeCategory,
      long_name: this.longName,
      translations_by_language: this.translationsByLanguage,
      collection_id: this.collectionId,
      building_id: this.buildingId,
      unit_type_id: this.unitTypeId,
      language: this.language,
      name: this.name,
      description: this.description,
      price: this.price,
      price_per_unit_of: this.pricePerUnitOf,
      price_per_interval_of: this.pricePerIntervalOf,
      permission: this.permission,
      vat_percentage: this.vatPercentage,
      is_cleaning_supply: this.isCleaningSupply
    };
  }

  static fromDTO(dto: OptionData): Option {
    return new Option(dto);
  }
}
